<script lang="ts">
	import type { BrandLogo } from "$lib/def/landing";
	import type { Observable } from "rxjs";
	
	import LazyBackgroundImage from "$lib/ui/shared/LazyBackgroundImage.svelte";

	export let brand: BrandLogo;
	export let url$: Observable<string>;
	export let index: number;
</script>

<a class="brand" href={$url$} data-testid={`item_${index}`}>
	<LazyBackgroundImage image={[brand.images.restaurant_logo, 80, 80]} alt={brand.restaurant_group_id.toString()} />
</a>